module.exports = __webpack_public_path__ + "static/project_haven-0a9c786654a7caf3be87e942c115d834.webp";